export default __webpack_public_path__ + "static/media/450.1fcd7551.jpg";